import { render } from "./InternalChat.vue?vue&type=template&id=77374b5e&scoped=true"
import script from "./InternalChat.vue?vue&type=script&lang=js"
export * from "./InternalChat.vue?vue&type=script&lang=js"

import "./InternalChat.vue?vue&type=style&index=0&id=77374b5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77374b5e"]])

export default __exports__